<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.blackPhone" style="width: 150px;" size="mini" placeholder="手机号" clearable></el-input>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="margin-left: 10px">搜索</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增黑名单</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="blackId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" :editOption="editOption" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑黑名单' : '新增黑名单'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="手机号" prop="blackPhone">
                <el-input v-model="form.blackPhone" style="width: 80%;" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="blackDes">
                <el-input v-model="form.blackDes" style="width: 80%;" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
            确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { getSysBlacklistList, addSysBlacklist, updateSysBlacklist, deleteSysBlacklist } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      dialog: false,
      edit: false,
      form: {
        blackPhone: '',
        blackDes: ''
      },
      rules: {
        blackPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      tableLoading: false,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      key: 'blackId',
      checkboxOption: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected, this.key);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys, this.key);
        },
      },
      cellSelectionOption: {
        enable: true,
      },
      editOption: {},
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      formDatas: {
        blackPhone: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "checkbox",
          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "blackPhone",
          key: "blackPhone",
          title: "手机号",
          align: "center",
        },
        {
          field: "blackDes",
          key: "blackDes",
          title: "备注",
          align: "center",
        },
        {
          field: "createusername",
          key: "createusername",
          title: "创建人",
          align: "center",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          align: "center",
        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 150,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                <el-button type="text" size="mini" on-click={() => this.editorgan(row)}>
                  编辑
                </el-button>
                <el-button type="text" size="mini" style="color: #F56C6C" on-click={() => this.deleteRow(row)}>
                  删除
                </el-button>
              </div>
            );
          },
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.tableLoading = true;
      getSysBlacklistList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 搜索
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    // 分页
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 新增弹窗
    BoxOpen() {
      this.edit = false;
      this.form = {
        blackPhone: '',
        blackDes: ''
      };
      this.dialog = true;
    },
    // 编辑
    editorgan(row) {
      this.edit = true;
      this.form = {
        blackId: row.blackId,
        blackPhone: row.blackPhone,
        blackDes: row.blackDes
      };
      this.dialog = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialog = false;
    },
    // 确认提交
    SureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const title = this.edit ? '确认编辑该黑名单？' : '确认新增该黑名单？';
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.edit) {
              updateSysBlacklist(this.form).then((res) => {
                this.$message.success('编辑成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('编辑失败');
              });
            } else {
              addSysBlacklist(this.form).then((res) => {
                this.$message.success('新增成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('新增失败');
              });
            }
          });
        }
      });
    },
    // 删除
    deleteRow(row) {
      this.$confirm('确认删除该黑名单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSysBlacklist({ blackId: row.blackId }).then((res) => {
          this.$message.success('删除成功');
          this.getList();
        }).catch(() => {
          this.$message.error('删除失败');
        });
      });
    },
    changeSelectedRowKeys() {},
    changeSelectAll() {},
  },
};
</script>

<style scoped>
</style>
